import './telematicsVideoList.css';
import TelematicsVideo from "../telematicsVideo/telematicsVideo";
import {videos} from "../../../data/videosData";
import Placeholder from "../../../shared/placeholder/placeholder";
import Video from "../../../shared/video/video";
import {format} from "date-fns";

const TelematicsVideoList = (
    {
        videoList = [],
        loader = false,
        handleShowVideoPlayer
    }) => {
    const tags = videos;
    return (
        <>
            {loader &&
                <ul className={'telematics-videos-list grid col-3 page-fade-in'}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((load) =>
                        <li key={load} className={`telematics-video`}>
                            <div className={'video-thumb margin-b-10'}>
                                <Placeholder height={'170px'}/>
                            </div>
                            <div className="">
                                <div className="margin-b-10"><Placeholder height={'28px'}/></div>
                                <div className=""><Placeholder height={'17px'} width={'80px'}/></div>
                            </div>
                        </li>
                    )}
                </ul>
            }
            {!loader &&
                <ul className={'telematics-videos-list grid col-3 page-fade-in'}>
                    {
                        videoList.map((video, index) =>
                            <TelematicsVideo
                                handleShowVideoPlayer={handleShowVideoPlayer}
                                video={video} key={video.videoId}/>
                        )
                    }
                </ul>
            }
        </>
    )
}

export default TelematicsVideoList;
